<template>
  <div class="bracket-card">
    <div class="bracket-card__participants">
      <BracketCardParticipant
        :participant="participant"
        :score="score"
        :result="result"
      />
      <BracketCardParticipant
        v-if="!result"
        :participant="match.team2"
        :score="match.team2_score"
      />
    </div>
  </div>
</template>

<script>
import BracketCardParticipant from "./BracketCardParticipant";

export default {
  name: "BracketCard",
  components: {
    BracketCardParticipant
  },
  props: {
    result: Boolean,
    match: {
      type: Object
    }
  },
  computed: {
    team() {
      return (this.result && this.match.winner) || 1;
    },
    participant() {
      return this.match[`team${this.team}`];
    },
    score() {
      return this.match[`team${this.team}_score`];
    }
  }
};
</script>

<style lang="scss">
$p: ".bracket-card";
$border-color: #aabbd0;

.bracket-card {
  font-size: 12px;
  margin: auto 0;
  width: 100%;
  display: flex;
  flex: 1 0;
  flex-direction: column;

  &__participants {
    position: relative;
    display: flex;
    flex: 1 0;
    flex-direction: column;
  }
}
</style>
